<template>
  <div class="announcements">
    <el-button class="editButton" @click="flag = !flag">{{
      flag ? "完成" : "编辑"
    }}</el-button>
    <div class="item" v-for="(item, index) in notice" :key="index">
      <!-- 标题 -->
      <div class="title">
        <div class="dian"></div>
        {{ item.typeGroup }}
      </div>
      <!-- 子项盒子 -->
      <div class="items-box">
        <div class="items" v-for="(items, indexs) in item.items" :key="indexs">
          <div class="label">{{ items.typeName }}：</div>
          <div class="input">
            <el-input v-model="items.notice_content" @blur="setNoticeContent(items)" :disabled="!flag"></el-input>
          </div>
          <div class="accessory">
            <span @click="accessory(items, index, indexs)">{{
      flag ? "添加附加" : "查看附件"
    }}</span>
            <span class="accessory_num">
              <span v-if="items.imgNum.length > 0">图片{{ items.imgNum.length }}</span>
              <span v-if="items.fileNum > 0">文件{{ items.fileNum }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加附件 -->
    <el-dialog title="附件" :visible.sync="dialogVisible" width="450px" center>
      <div class="imgList">
        <div class="item">
          <el-upload v-if="flag" class="avatar-uploader" drag :action="baseURL + '/api/common/uploadFile'"
            :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" name="file">
            <el-button size="small" type="primary">图片上传</el-button>
          </el-upload>
          <div v-if="items.image1" class="img">
            <img :src="items.image1" alt="" />
            <div class="inco">
              <i class="el-icon-search" @click="handleImg(items.image1)"></i>
              <i class="el-icon-delete" @click="delItem(1)" v-if="flag"></i>
            </div>
          </div>
        </div>
        <div class="item">
          <el-upload v-if="flag" class="avatar-uploader" drag :action="baseURL + '/api/common/uploadFile'"
            :show-file-list="false" :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload" name="file">
            <el-button size="small" type="primary">图片上传</el-button>
          </el-upload>
          <div v-if="items.image2" class="img">
            <img :src="items.image2" alt="" />
            <div class="inco">
              <i class="el-icon-search" @click="handleImg(items.image2)"></i>
              <i class="el-icon-delete" @click="delItem(2)" v-if="flag"></i>
            </div>
          </div>
        </div>
        <div class="item">
          <el-upload v-if="flag" class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" drag
            :show-file-list="false" :on-success="handleAvatarSuccess3" :before-upload="beforeAvatarUpload" name="file">
            <el-button size="small" type="primary">图片上传</el-button>
          </el-upload>
          <div v-if="items.image3" class="img">
            <img :src="items.image3" alt="" />
            <div class="inco">
              <i class="el-icon-search" @click="handleImg(items.image3)"></i>
              <i class="el-icon-delete" @click="delItem(3)" v-if="flag"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="file">
        <el-upload v-if="flag" class="upload-demo" drag :action="baseURL + '/api/common/uploadFile'"
          :on-success="handleAvatarSuccess4" name="file" multiple :file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <div class="fileTeat" v-if="items.file">
          <span>文件下载 ：
            <a :href="items.file" target="_blank">
              <i class="el-icon-document"></i></a></span>
          <span class="fr" v-if="flag">文件删除 ：
            <a href="javascript:;" @click="delItem(4)">
              <i class="el-icon-delete"></i></a></span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="flag">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setNoticeFile">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 查看大图 -->
    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="imageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
  },
  components: {},
  data() {
    return {
      fileList: [],
      user_token: localStorage.getItem("user_token"),
      flag: false, // 是否禁用
      datas: {
        userId: this.$route.query.id,
      },
      dialogVisible: false,
      notice: [], //列表数据

      items: {
        image1: "",
        image2: "",
        image3: "",
        file: "",
      }, // 附加件
      index: 0,
      indexs: 0,
      // 查看大图
      imageUrl: "",
      imgDialogVisible: false,
    };
  },
  created() {
    this.getNotice();
  },
  methods: {
    getNotice() {
      this.$api.clienteleApi
        .getNotice({ user_id: this.$route.query.userID })
        .then((res) => {
          this.notice = res.data;
          this.notice.forEach((item) => {
            item.items.forEach((items) => {
              items.fileNum = items.file ? 1 : 0;
              items.imgNum = [];
              if (items.image1) {
                items.imgNum.push(items.image1);
              }
              if (items.image2) {
                items.imgNum.push(items.image2);
              }
              if (items.image3) {
                items.imgNum.push(items.image3);
              }
            });
          });
        });
    },
    //设置注意事项文字
    setNoticeContent(item) {
      if (item.notice_content == this.datas.noticeContent) return false;
      this.datas.noticeType = item.typeId;
      this.datas.noticeContent = item.notice_content;
      this.datas.user_id = this.$route.query.userID;
      this.$api.clienteleApi.setNoticeContent(this.datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
      });
    },
    // 查看附加件
    accessory(item, index, indexs) {
      this.dialogVisible = true;
      this.index = index;
      this.indexs = indexs;
      let items = JSON.stringify(item);
      this.items = JSON.parse(items);
    },
    // 上传图片1
    handleAvatarSuccess(file) {
      this.items.image1 = file.data;
      this.$message.success("上传成功");
    },
    // 删除文件
    delItem(i) {
      if (i == 1) {
        this.items.image1 = "";
      } else if (i == 2) {
        this.items.image2 = "";
      } else if (i == 3) {
        this.items.image3 = "";
      } else {
        this.items.file = "";
      }
      this.$message.success("删除成功");
    },
    // 上传图片2
    handleAvatarSuccess2(file) {
      this.items.image2 = file.data;
      this.$message.success("上传成功");
    },
    // 上传图片3
    handleAvatarSuccess3(file) {
      this.items.image3 = file.data;
      this.$message.success("上传成功");
    },
    // 上传文件
    handleAvatarSuccess4(file) {
      this.items.file = file.data;
      this.$message.success("上传成功");
    },
    // 只能上传图片的类型 jpg，png
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG、PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    // 下载
    downloadFile() {
      let a = document.createElement("a");
      a.href = this.items.file;
      //   a.target = "_blank";
      a.download = this.items.file;
      a.click();
    },

    //  查看大图
    handleImg(file) {
      this.imageUrl = file;
      this.imgDialogVisible = true;
    },
    // 保存
    setNoticeFile() {
      this.items.noticeType = this.items.typeId;
      this.items.user_id = this.$route.query.userID;
      this.$api.clienteleApi.setNoticeFile(this.items).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.getNotice();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.announcements {
  margin-top: 40px;
  position: relative;
}

.editButton {
  position: absolute;
  right: 10px;
}

.item {
  .title {
    text-align: left;
    margin: 0;

    .dian {
      width: 10px;
      height: 10px;
      background-color: #027db4;
      border-radius: 50%;
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
    }
  }

  .items-box {
    width: 1200px;
    padding: 20px 0;
    margin-left: 4px;
    border-left: 1px solid #ccc;
    margin-bottom: 50px;

    .items {
      display: flex;
      line-height: 40px;
      margin-bottom: 10px;

      .label {
        flex: 1;
        text-align: right;
      }

      .input {
        flex: 8;
        margin: 0 10px;
      }

      .accessory {
        flex: 1.5;
        color: #027db4;
        cursor: pointer;

        .accessory_num {
          color: #333;
          margin-left: 10px;
          font-size: 12px;
        }
      }
    }
  }
}

.imgList {
  display: flex;

  .item {
    flex: 1;
    margin-right: 20px;

    .img {
      position: relative;
      width: 118px;
      height: 118px;
      z-index: 99;
      margin-bottom: 20px;
      text-align: center;

      &:hover .inco {
        display: block;
      }

      .inco {
        position: absolute;
        top: 0;
        left: 0;
        height: 120px;
        width: 120px;
        text-align: center;
        display: none;
        background: rgba(0, 0, 0, 0.5);

        i {
          text-align: center;
          line-height: 120px;
          cursor: pointer;
          font-size: 20px;
          color: #fff;

          &:nth-child(1) {
            margin-right: 20px;
          }
        }

        // display: none;
      }

      img {
        width: 118px;
        height: 118px;
      }
    }

    .avatar-uploader {
      margin-left: 20px;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: 36px;
    }
  }
}

.file {
  margin-top: 20px;

  /deep/ .el-upload {
    width: 100%;
  }

  /deep/.el-upload-dragger {
    width: 400px;
  }

  /deep/.is-success {
    display: none;
  }

  .fileTeat {
    margin: 20px 0 0;

    i {
      font-size: 30px;

      &:hover {
        color: #027db4;
      }
    }
  }
}
</style>
